var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 647.05 500.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e59f3c;}.cls-2{fill:#fff;stroke:#e59f3c;}.cls-2,.cls-3{stroke-miterlimit:10;stroke-width:4px;}.cls-3{fill:none;stroke:#1f2dd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "155.77 11.78 221.79 132.81 151.73 247.28 23.74 249.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "557.73 17.77 424.37 17.77 357.69 132.5 427.16 247.24 557.73 247.24 624.41 132.5 557.73 17.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "357.69 130.61 222.15 130.61 154.37 244.39 222.15 358.18 363.82 358.18 427.16 247.24 357.69 130.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "559.26 247.24 428.97 247.24 363.82 358.18 428.97 469.12 559.26 469.12 624.41 358.18 559.26 247.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 153.86,
    cy: 15.93,
    r: 15.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 427.16,
    cy: 485.06,
    r: 15.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 562.86,
    cy: 485.06,
    r: 15.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.93,
    cy: 249.44,
    r: 15.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 217.53,
    cy: 367.57,
    r: 15.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 629.12,
    cy: 358.18,
    r: 15.93
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.57908325f16e0e16505ef54d03a9bef8.svg";
export { ForwardRef as ReactComponent };